import { API } from '../helpers/fetcher'

export const walleyAuthentication = async params =>
  API.post('v1/transaction/walley/authenticate', params)
